import api from './baseApi';
import type { GenericCatalog, GenericPodProduct, GenericPodVariant, ProductFilters } from '../typings/podProviders';
import { Provider } from '@/utils/PodProvider.enum';

export const getPodProductsCatalog = (provider: string, page = 1, filters?: unknown): Promise<GenericCatalog> =>
    api.post('podProvider/productsCatalog', { provider, page, filters }).then(({ data }) => data);

export const getPodProductDetails = (provider: string, productId: string): Promise<GenericPodProduct> =>
    api.post('podProvider/productDetails', { provider, productId }).then(({ data }) => data);

export const getPodProductVariants = (
    provider: string,
    productId: string,
    filters?: unknown
): Promise<GenericPodVariant[]> => {
    return api
        .post('podProvider/productVariants', {
            provider,
            productId,
            filters
        })
        .then(({ data }) => data);
};

export const getPodProductFilters = (provider: string, productId?: string): Promise<ProductFilters[]> =>
    api
        .get('podProvider/productFilters', {
            params: { provider, productId }
        })
        .then(({ data }) => data);

export const saveVariantsPrice = (
    provider: Provider,
    podProductId: string,
    variantPrices: Record<string, number>
): Promise<{ updated: number }> => {
    return api
        .post('podProvider/saveVariantsPrice', {
            provider,
            podProductId,
            variantPrices
        })
        .then(({ data }) => data);
};

export const getVariantsPrice = (
    provider: string,
    variantIds: string[]
): Promise<Record<string, number>> => {
    return api
        .get('podProvider/variantsPrice', {
            params: { provider, variantIds }
        })
        .then(({ data }) => data);
};
